<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/93/title-bg.png" alt="" />
            <div class="technological-process">

                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/93/title-1.png" alt="" />
                    <div class="content">
                        <div class="des">
                            （一）实施“天府高端引智计划”，对入选的国外院士按规定给予最高不超过400万元的项目资助。
                                <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86728520">028-86728520</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        科技厅人事处
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （二）实施“天府学者”特聘专家制度，柔性引进院士等高层次人才，省财政和设岗单位给予每个岗位合计不低于40万元的资助。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86765106">028-86765106</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        人社厅专技处
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （三）符合条件的国（境）外或省外引进的高层次急需紧缺人才，可向省委组织部（省委人才办）申报省级重大人才计划，入选后一次性给予每人50万元至200万元资助。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-63092480">028-63092480</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        省委组织部
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （四）符合条件的在川企事业单位的全职在岗人员，可向省委组织部（省委人才办）申报省级重大人才计划，入选后一次性给予每人10万元至80万元资助。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-63092480">028-63092480</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        省委组织部
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （五）为“天府学者”特聘专家入选者提供特殊支持经费，省财政给予每个岗位20万元资助，设岗单位配套的资助经费不低于省财政标准。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86765106">028-86765106</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        人社厅专技处
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （六）符合条件的国（境）外高端人才，可向四川省科学技术厅（四川省外国专家局）申报“天府高端引智计划”，给予不超过80万元/项·年的项目资助，同一项目最多连续资助5年。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86728520">028-86728520</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        科技厅人事处
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （七）设立博士后创新人才支持项目，每个项目给予40万元资助。博士后日常经费资助标准提高至每人16万元。博士后科研项目特别资助扩大到100项，每项最高给予20万元资助。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86763106">028-86763106</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        人社厅专技处
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                             （八）符合条件的留学回国人员，可向人力资源社会保障厅申报留学人员回国创业启动经费、科技活动项目择优资助经费，分别给予不超过30万元、10万元的项目资助。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86763106">028-86763106</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        人社厅专技处
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （九）符合条件的省学术技术带头人及后备人选、进站博士后等，可向人力资源社会保障厅申报学术技术带头人培养支持经费、博士后科研经费，给予不超过10万元的项目资助。
                                <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86763106">028-86763106</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        人社厅专技处
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （十）符合条件的科技创新创业人才，可向科技厅申报四川省青年科技基金、科技创业领军人才计划，给予不超过50万元的项目资助。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86728520">028-86728520</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        科技厅人事处
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （十一）对符合条件的引进优秀人才，省财政给予5万元/人的一次性安家补助。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-63092480">028-63092480</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        省委组织部
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/93/title-2.png" alt="" />
                    <div class="content">
                        <div class="des">
                            （一）院士团队以我省单位为第一完成单位取得科技成果，获国家科学技术奖的按1:1给予配套奖励。中央科研院所院士团队在川转化的科技成果项目，省级财政科技计划给予100万元经费支持。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86728520">028-86728520</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        科技厅人事处
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （二）支持院士团队牵头参与我省重大战略规划咨询论证、开展科技核心问题战略咨询研究，依托我省工程科技战略咨询研究项目给予最高不超过200万元的项目经费资助。
                                <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86728520">028-86728520</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        科技厅人事处
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （三）对省级重大人才计划入选创新团队、创业团队，一次性给予每个团队200万元至500万元资助。对创新创业团队中经评估具有重大产业化前景的战略发展项目，集成各部门政策资源，采取项目资助、创业扶持、股权投资、贷款贴息等方式，可给予最高5000万元综合资助。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-63092480">028-63092480</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        省委组织部
                                    </div>
                            </div>
                        </div>
                        <div class="des">
                            （四）企事业单位的高层次创新团队，可向科技厅申报青年科技创新研究团队项目，分培育项目、重点项目两个类别，按相关规定评定后分别给予30万元、100万元资助。
                            <div class="dutyphone">
                                    <div class="number">
                                        <span class="label">政策咨询电话：</span>
                                        <div>
                                            <a href="tel:028-86728520">028-86728520</a>
                                        </div>
                                    </div>
                                    <div class="unit">
                                        <span class="label">责任单位：</span>
                                        科技厅人事处
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #d4e0ff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.87rem 0.23rem 0.3rem;
                    text-align: left;
                    line-height: 0.44rem;
                    position: relative;
                    overflow: hidden;

                    .label {
                        width: 2.17rem;
                        height: 0.6rem;
                        background: #739bfe;
                        position: absolute;
                        top: 0;
                        display: flex;
                        left: 0;
                        align-items: center;
                        padding-left: 0.11rem;

                        color: #fff;

                        .letter {
                            width: 0.36rem;
                            height: 0.36rem;
                            background-color: #ffffff;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border-radius: 0.25rem 0px 0px 0px;
                            color: #739bfe;
                            margin-right: 0.12rem;
                            transform: translateY(-0.02rem);
                        }
                    }
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
            line-height: 0.44rem;

                text-align: left;
                color: #4e4e4e;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.2rem;
                    position: relative;
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.5rem;
                    position: relative;

                    .title {
                        font-size: 0.3rem;
                        font-weight: bold;
                        color: #333333;
                    }

                    .item {
                        margin-top: 0.22rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 100%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 3.31rem;
                            height: 0.49rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.08rem;

                            .line-num {
                                width: 0.39rem;
                                height: 0.39rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.14rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                height: 1.94rem;
            }
        }
    }
}
</style>
